export default "__VITE_ASSET__BaRS3gal__"